<app-navigator [navigator]="navigator"></app-navigator>
<hr>
<ng-container *ngIf="currentUser; else waiting">
   
    <div class="actionBar">
        <label class="roboSubTitle col">{{'users.editor.company' | translate}}: {{currentUser.denominazione}} | {{'users.personal.piva' | translate}}: {{currentUser.partita_iva}}</label>
        <!--<br *ngIf="innerWidth! <= 767">
        <div>
            
            <button *ngIf="managing && userInfo?.ruolo != 4" type="submit" class="btn btn-primary" style="margin-left: 10px;" [routerLink]="['../../users']">{{ 'general.changeUser' | translate }}</button>
            <button *ngIf="!managing  && userInfo?.ruolo != 4" type="submit" class="btn btn-primary" style="margin-left: 10px;" [routerLink]="['../users']">{{ 'general.changeUser' | translate }}</button>
        </div>-->
    </div>
    <hr>
    
        <div class="row tab-container">
            <div class="">
                <div class="tab" role="tabpanel">
                    <!-- Nav tabs -->
                    <ul class="nav nav-tabs" role="tablist">
                        <li role="presentation" class="nav-item"><button class="nav-link" (click)="goTo('rubrica')" [ngClass]="{'active':section === 'rubrica'}">{{ 'configuration.tabs.rubrica' | translate }}</button></li>
                        <li role="presentation" class="nav-item"><button class="nav-link" (click)="goTo('sezionali')" [ngClass]="{'active':section === 'sezionali'}">{{ 'configuration.tabs.sectionals' | translate }}</button></li>
                        <li role="presentation" class="nav-item"><button class="nav-link" (click)="goTo('articoli')" [ngClass]="{'active':section === 'articoli'}">{{ 'configuration.tabs.items' | translate }}</button></li>
                        <!--<li role="presentation" class="nav-item"><button class="nav-link" (click)="goTo('etichette')" [ngClass]="{'active':section === 'etichette'}">{{ 'configuration.tabs.labels' | translate }}</button></li>
                        <li *ngIf="userInfo!.role == '1'" role="presentation" class="nav-item"><button class="nav-link" (click)="goTo('dashboard')" [ngClass]="{'active':section === 'dashboard'}">Dashboard</button></li>-->
                    </ul>
                    <!-- Tab panes --> 
                    <div class="tab-content">
                       <ng-container [ngSwitch]="section">
                            <div *ngSwitchCase="'rubrica'">
                                <app-rubrica [userId]='currentUserId'></app-rubrica>
                            </div>

                            <div *ngSwitchCase="'sezionali'">
                                <app-sectionals [userId]='currentUserId'></app-sectionals>
                            </div>

                            <div *ngSwitchCase="'articoli'">
                                <app-items [userId]='currentUserId'></app-items>
                            </div>

                            <div *ngSwitchCase="'etichette'">
                                <app-labels [userId]='currentUserId'></app-labels>
                            </div>
                            <ng-container >
                                <div *ngSwitchCase="'dashboard'">
                                    <app-conf-dashboard [userId]='currentUserId'></app-conf-dashboard>
                                </div>
                            </ng-container>
                       </ng-container>
                        
                    </div>
                </div>
            </div>
        </div>
    
</ng-container>
<ng-template #waiting>
    <app-loading></app-loading>
</ng-template>
<router-outlet></router-outlet>